import React, { useState } from 'react'
import { CloudDownload } from '@material-ui/icons'
import { Menu } from '@material-ui/core'
import { StyledButton, StyledMenuItem } from '../../../../../theme/Global'

const ExportButton = ({
  isLoading,
  showExportDropdown,
  exportOptions,
  eventHandlers
}) => {
  const [anchorEl, setAnchorEl] = useState(null)

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleExport = (event) => {
    if (event.target.id === 'update service') {
      eventHandlers.exportUpdateService()
    } else if (event.target.id === 'subscription audit') {
      eventHandlers.exportItems()
    } else {
      eventHandlers.export()
    }
    handleClose()
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  return (
    showExportDropdown ? (
      <React.Fragment>
        <StyledButton
          data-testid="export-button"
          disabled={isLoading}
          onClick={handleClick}
        >
          Service CSVs &nbsp; <CloudDownload />
        </StyledButton>
        <Menu
          open={!!anchorEl}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left'
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'left'
          }}
          getContentAnchorEl={null}
        >
          {exportOptions.map((option) => (
            <StyledMenuItem
              data-testid={`${option.toLowerCase()}-export-button`}
              key={option}
              id={option.toLowerCase()}
              onClick={handleExport}
            >
              {option}
            </StyledMenuItem>
          ))}
        </Menu>
      </React.Fragment>
    ) : (
      <React.Fragment>
        <StyledButton
          data-testid="export-button"
          disabled={isLoading}
          onClick={handleExport}
        >
          CSV&nbsp; <CloudDownload />
        </StyledButton>
      </React.Fragment>
    ))
}

export default ExportButton
